import {
    ChangeDetectionStrategy,
    Component,
    forwardRef,
    Input,
    ViewChild,
    ViewEncapsulation,
} from '@angular/core';
import {
    ControlValueAccessor,
    NG_VALUE_ACCESSOR,
} from '@angular/forms';
import { UiParameterCollectionComponent } from '@components/shared/ui-parameter-collection/ui-parameter-collection.component';
import { IPackageArgumentCollection } from '@models';

@Component({
    selector: 'ui-process-io-parameters',
    templateUrl: './process-io-parameteres.component.html',
    styleUrls: [
        './process-io-parameters.component.scss',
    ],
    changeDetection: ChangeDetectionStrategy.OnPush,
    encapsulation: ViewEncapsulation.None,
    providers: [{
        provide: NG_VALUE_ACCESSOR,
        useExisting: forwardRef(() => ProcessIOParametersComponent),
        multi: true,
    }],
})
export class ProcessIOParametersComponent implements ControlValueAccessor {
    @Input()
    public placeholder?: string;

    @Input()
    public args!: IPackageArgumentCollection;

    @Input()
    public editable?: boolean;

    public get isOpen(): boolean {
        return !!this._inputCollection &&
            this._inputCollection.isOpen;
    }

    public value?: string;

    @ViewChild('inputParameterCollection', { static: false })
    private _inputCollection?: UiParameterCollectionComponent;

    public onChange: (_: any) => void = () => { };
    public onTouch: () => void = () => { };

    public writeValue(value: string) {
        this.value = value;
        this.onChange(value);
    }

    public registerOnChange(fn: (_: any) => void): void {
        this.onChange = fn;
    }

    public registerOnTouched(fn: () => void): void {
        this.onTouch = fn;
    }

    public onModelChange(value: string) {
        this.value = value;
        this.onChange(value);
    }
}
